var _path, _path2, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBacgroundCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1050,
    height: 137,
    viewBox: "0 0 1050 137",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2022_1722)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1040 0H10C4.47715 0 0 4.47715 0 10V127C0 132.523 4.47715 137 10 137H1040C1045.52 137 1050 132.523 1050 127V10C1050 4.47715 1045.52 0 1040 0Z",
    fill: "url(#paint0_linear_2022_1722)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2022_1722",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1050,
    height: 137
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1040 0H10C4.47715 0 0 4.47715 0 10V127C0 132.523 4.47715 137 10 137H1040C1045.52 137 1050 132.523 1050 127V10C1050 4.47715 1045.52 0 1040 0Z",
    fill: "url(#paint1_linear_2022_1722)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2022_1722)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M77 167C134.438 167 181 120.438 181 63C181 5.56239 134.438 -41 77 -41C19.5624 -41 -27 5.56239 -27 63C-27 120.438 19.5624 167 77 167Z",
    fill: "url(#paint2_linear_2022_1722)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2022_1722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1016 25H640V112H1016V25Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2022_1722",
    x: 560,
    y: -55,
    width: 536,
    height: 247,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40,
    result: "effect1_foregroundBlur_2022_1722"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2022_1722",
    x1: 0,
    y1: 68.5,
    x2: 1050,
    y2: 68.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE2C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2022_1722",
    x1: 525,
    y1: 0,
    x2: 525,
    y2: 137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE2C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2022_1722",
    x1: 77,
    y1: -41,
    x2: 77,
    y2: 167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2022_1722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1050,
    height: 137,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBacgroundCard);
export default __webpack_public_path__ + "static/media/bacgroundCard.bb057c6f3f37bf3cb5273f494c024ca2.svg";
export { ForwardRef as ReactComponent };